import React from 'react';

const categoryStyles = {
    stock: 'bg-blue-50 text-blue-600 border-blue-100',
    industry: 'bg-purple-50 text-purple-600 border-purple-100',
    macro: 'bg-orange-50 text-orange-600 border-orange-100',
    earnings: 'bg-green-50 text-green-600 border-green-100',
    outlook: 'bg-indigo-50 text-indigo-600 border-indigo-100',
};

const CategoryPill = ({ category, className = '' }) => {
    const label = category.charAt(0).toUpperCase() + category.slice(1);
    const style = categoryStyles[category] || 'bg-gray-50 text-gray-600 border-gray-100';

    return (
        <span className={`px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider border ${style} ${className}`}>
            {label}
        </span>
    );
};

export default CategoryPill;
